module.exports = __webpack_public_path__ + "img/homePageLogo.7b521487.png";